import { useNavigate, useSearch } from '@tanstack/react-router';

import { OverviewSupplierCompanySelect } from '../../common/form-elements/CompanySelect/OverviewSupplierCompanySelect';
import { useRole } from '../../common/hooks/useRole';

export const CustomerFilterActions = () => {
    const role = useRole();
    const search = useSearch({ from: '/_app/customers' });
    const navigate = useNavigate({ from: '/customers' });

    if (role.isOneCompanyUser()) {
        return null;
    }

    return (
        <OverviewSupplierCompanySelect
            value={search.supplierIds}
            onChange={(supplierIds) => {
                navigate({ search: (previousSearch) => ({ ...previousSearch, supplierIds, page: 0 }) });
            }}
        />
    );
};
